<template>
    <div class="container-event">
        <div 
            :key="id" 
            :class="[status, {'is-placeholder': isPlaceholder }]"
            class="post card-status-border-color card-status-background-color hover-card-status-background-color hover-card-status-border-color"
            @mousedown="handleMouseDown"
        >
            <div v-if="image" :class="type" class="post-image">
                <img :src="image"/>
                <div :class="type" class="type-post"></div>
            </div>
            <div class="container-info">
                <div class="top">
                    <div class="badge-status" :class="{loading: isLoading}" :status="status">
                        {{formatDate}}
                    </div>
                    
                    <div v-if="page" class="avatar" :class="page.network">
                        <Tooltip :text="getPage.name">
                            <img :src="page.avatar || 'img/avatar.jpg'">
                        </Tooltip>
                    </div>
                </div>
                <div class="content">
                    <p>{{content}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'

    export default {

        components: {
            Tooltip
        },
        
        props: {
            id: {
                type: [String, Number],
                required: true
            },
            status: {
                type: String,
                default: 'pending'
            },
            image: {
                type: String,
            },
            type: {
                type: 'text' | 'video' | 'link' | 'image' | 'story',
                default: 'standard'
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            date: {
                type: [String, Number, Date],
                default: null
            },
            page: {
                type: Object,
            },
            content: {
                type: String,
            },
            isPlaceholder: {
                type: Boolean,
                default: false,
            },
            isDraggable: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                mouseDownData: null,
            }
        },

        methods: {
            handleMouseDown(e) {
                if (this.isDraggable && !this.isLoading) {
                    this.mouseDownData = {
                        e: e,
                        eventId: this.id,
                        el: this.$el,
                        startX: e.clientX,
                        startY: e.clientY,
                    }
                    document.addEventListener('mousemove', this.handleMouseMove);
                }
                document.addEventListener('mouseup', this.handleMouseUp);
            },

            handleMouseMove(e) {
                const dx = e.clientX - this.mouseDownData.startX;
                const dy = e.clientY - this.mouseDownData.startY;
                if (Math.sqrt(dx * dx + dy * dy) < 5) return;
                this.$emit('eventDragStart', this.mouseDownData);
                document.removeEventListener('mousemove', this.handleMouseMove);
                document.removeEventListener('mouseup', this.handleMouseUp);
            },

            handleMouseUp(e) {
                document.removeEventListener('mousemove', this.handleMouseMove);
                document.removeEventListener('mouseup', this.handleMouseUp);
                console.log("event clicked");
                this.$emit('eventClick', this.id);
            }
        },

        computed: {
            formatDate() {
                let dateInstance = this.date;

                if (dateInstance instanceof Date === false) {
                    dateInstance = new Date(dateInstance)
                }

                return dateInstance.toLocaleTimeString('fr-FR', {
                    hour: 'numeric',
                    minute: 'numeric'
                }).replace(':','h');
                
            },

            getPage() {
                return this.$store.getters['selectPage/selectPageAllPages'][this.page.id];
            }
        },

        destroyed () {
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
        },
        
    }
</script>


<style lang="scss" scoped>
    .post {
        display: flex;
        padding: 3px;
        border-width: 0.6px;
        border-style: solid;
        border-radius: 5px;
        gap: 3px;
        width: 100%;
        height: 38px;
        cursor: pointer;
        user-select: none; // Empêche la sélection du texte
        -webkit-user-select: none; // Pour Safari
        -ms-user-select: none; // Pour IE/Edge

        &.is-dragging {
            cursor: pointer;
        }

        &.is-placeholder {
            visibility: hidden; 
            opacity: 0;
            pointer-events: none;
        }

        * {
            cursor: pointer;
        }

        .post-image {
            height: 100%;
            width: auto;
            aspect-ratio: 1/1;
            border-radius: 4px;
            overflow: hidden;
        }

        .container-info {
            display: flex;
            flex-direction: column;
            width: 0;
            flex-grow: 1;
            height: 100%;
            height: 31px;
            justify-content: space-evenly;
            padding: 2px 0;
            gap: 2px;
            margin-left: 3px;
            .top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 3px;
                gap: px;
                .badge-status{
                    height: 15px;
                    line-height: 15px;
                    font-size: 9px;
                    padding-right: 6px;
                    padding-left: 5px;
                    gap: 3px;
                    display: flex;
                    align-items: center;
                    &::before {
                        height: 15px;
                        width: min-content;
                        line-height: 15px;
                        font-size: 8px;
                    }

                    &.loading  {
                        &::before {
                            content: '\f110';
                            animation: spin 1s linear infinite;
                        }
                    }

                }


                .avatar {

                    height: 16px;
                    width: 16px;
                    padding: 0;
                    border: none;
                    // border: solid transparent 2px;
                    flex-shrink: 0;

                    &::before {
                        width: 8px;
                        height: 8px;
                        bottom: -1px;
                        right: -1px;
                        z-index: 1;
                    }
                }
            }
            .content {
                display: flex;
                align-items: center;
                p {
                    color: #121826;
                    font-weight: 500;
                    font-size: 10px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    line-clamp: 1;
                    -webkit-box-orient: vertical;
                    text-wrap: wrap;
                }
                
            }
        }
    }

</style>